export default "__VITE_ASSET__vMgrxotL__"